import React from 'react';
import PropTypes from 'prop-types';

import { GeoJsonLayer } from 'mapping/leaflet';

import { styleMethods } from 'dataviz/config/map';

/** A map layer for depicting field boundaries but not including its zone shapes. */
const FieldOutlineLayer = ({boundaryGeoJson, map}) =>
  (<GeoJsonLayer
    geoJson={boundaryGeoJson}
    layerStyle={styleMethods.outline}
    map={map}
  />);

FieldOutlineLayer.propTypes = {
  boundaryGeoJson: PropTypes.object.isRequired,
  map: PropTypes.object // Inserted by mapping/leaflet.
};
export default FieldOutlineLayer;
